import { IOSMResponse } from '@eventr/common'
import { ColoursObj } from '@eventr/common-storybook'
import { CardText } from '../subComponents/cardText'
import { ColouredIcon } from '../subComponents/colouredIcon'
import { RowInfo } from '../subComponents/rowInfo'
import { RowInfoAddress } from '../subComponents/rowInfoAddress'

interface IActivityExtraInfoProps {
    location?: string
    address?: IOSMResponse
}

export const ActivityExtraInfo = ({
    location,
    address,
}: IActivityExtraInfoProps) => {
    return (
        <>
            {location && (
                <RowInfo
                    start={
                        <ColouredIcon
                            bubble
                            bubbleColour={ColoursObj.coreBrights.secondary}
                            name={'Location'}
                        />
                    }
                    middle={<CardText useMarkdown>{location}</CardText>}
                />
            )}
            {address && <RowInfoAddress address={address} />}
        </>
    )
}
